import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import VjoonImage from '../src/image/image';
import { insertContentToWriter, requireViewRange } from './utils';

export default class InsertContent extends Plugin {

	/**
	 * @inheritDoc
	 */
	constructor( editor ) {
		super( editor );

		/**
		 * The configuration of this plugins.
		 *
		 * @private
		 * @type {Object}
		 */
		this._config = editor.config.get( 'insertContent' ) || {};
	}

	static get pluginName() {
		return 'vjoonInsertContent';
	}

	/**
	 * @inheritDoc
	 */
	static get requires() {
		return [ VjoonImage ];
	}

	init() {
		const editor = this.editor;
	}

	insertContent( content, event, useOptimalPosition = true ) {
		event.stopPropagation();
		event.preventDefault();
		const viewRange = requireViewRange( this.editor, this.editor.editing.view, event );
		const contentToInsert = content;
		this.editor.model.change( writer => {
			insertContentToWriter(this.editor, writer, viewRange, contentToInsert, useOptimalPosition);
		} );
	}
}
